export default __webpack_public_path__ + "static/media/301.fb70b837.png";